export { Property1Copy } from "./Property1Copy";
